import {
    isPlayerAction,
    Projection,
    SharedGameState,
    useGameStore,
} from '@glark-newco/game-library';
import dayjs, {Dayjs} from 'dayjs';
import {isStartTimerPayload} from '../SupplyChainPayloadTypes';

export interface GameTimerSlice extends SharedGameState {
    gameEndTime?: Dayjs;
}

export const gameTimerProjection: Projection<GameTimerSlice> = {
    name: 'gameTimerProjection',
    project: (state, newEvents) => {
        let gameEndTime = state.gameEndTime;
        let modified = false;

        newEvents.forEach(ev => {
            if (isPlayerAction(ev) && isStartTimerPayload(ev.payload)) {
                const payload = ev.payload;
                // The timer starts at the event timestamp plus the configured duration.
                gameEndTime = dayjs(ev.timestamp).add(payload.duration, 'minutes');
                modified = true;
            }
        });

        return modified ? {gameEndTime} : {};
    },
    reset: () => ({gameEndTime: undefined}),
};

export const useGameEndTime = () =>
    useGameStore((s: GameTimerSlice) => s.gameEndTime);

export const useIsGameStarted = () =>
    useGameStore((s: GameTimerSlice) => !!s.gameEndTime);
